import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import teacherServices from "../../../services/teacherServices";
import { formatCustomDate } from "../../../utils/formatCustomDate";
import Button from "../../Button";
import CustomDataTable from "../../CustomDataTable";
import Modal from "../../Modal";

const ModifyingHistoryModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [studentName, setStudentName] = useState("");
  const [lessonName, setLessonName] = useState("");
  const [selectedLessonID, setSelectedLessonID] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal(studentName, selectedLesson, selectedLessonID) {
      setIsOpen(true);
      setStudentName(studentName);
      setLessonName(selectedLesson);
      setSelectedLessonID(selectedLessonID);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const fetchStudentModifyingHistory = async () => {
    if (!selectedLessonID) return;
    setLoading(true);
    try {
      const response = await teacherServices.getStudentModifyingHistory(selectedLessonID);
      setHistory(response || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchStudentModifyingHistory();
    }
  }, [isOpen]);

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const columns = [
    {
      name: t("status"),
      field: "status",
      body: (rowData) => <span className="font-medium text-blue-600 dark:text-white">{rowData.status}</span>,
    },
    {
      name: t("date"),
      field: "created_at",
      body: (rowData) => (
        <span className="text-mutedText dark:text-dark-mutedText">
          {formatCustomDate(rowData.created_at)}
        </span>
      ),
    },
  ];

  return (
    <Modal
      footer={
        <div className="flex items-center justify-end space-x-2">
          <Button color="white" variant="outlined" onClick={handleCloseModal} label={t("cancel")} />
        </div>
      }
      isOpen={isOpen}
      onClose={handleCloseModal}
      className="w-full max-w-2xl px-0"
      contentClassname="p-0"
      header={
        <h3 className="text-2xl font-bold text-blue-500">
          {studentName} - {lessonName}
        </h3>
      }
    >
      <div className="col-span-12 rounded-xl bg-white px-6 py-4 dark:bg-dark-surface">
        <CustomDataTable
          header={false}
          columns={columns}
          data={history}
          withPagination={false}
          withSort={false}
          loading={loading}
        />
      </div>
    </Modal>
  );
});

export default ModifyingHistoryModal;
